import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { Form, Row, Col, Image, Button } from "react-bootstrap";
import { TextField, InputLabel } from "@material-ui/core";
import Alert from "react-s-alert";
import { useFormik } from "formik";
import * as yup from "yup";
import AlertDialogProgress from "../../../reusableComponents/allPopupReusable/DialogProgression";
import InputNumberFunc from "../../../../function/InputNumberFunc";
import SimpleReactLightbox from "simple-react-lightbox";
import MultipleImageUploadComponent from "../../../reusableComponents/imageUploadReusableComponent/MultipleImageUploadComponent";
import { serverApi, imageUploadSize } from "../../../../config/Keys";
import countryJson from "../../../localization/country.json";
import moment from "moment";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import isEmpty from "../../../../store/validation/is-Empty";
import { ReusableOnboardingButton } from "../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { NewInputText } from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";

const gstInFormat =
  /^([0]{1}[1-9]{1}|[1-2]{1}[0-9]{1}|[3]{1}[0-7]{1})([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$/;
const pan_cardFormat = /^[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}$/;
const aadhaarCardFormat = /^[2-9]{1}[0-9]{3}\s[0-9]{4}\s[0-9]{4}$/;
const tanNumberFormat = /^[a-zA-Z]{4}[0-9]{5}[a-zA-Z]{1}$/;

const BankKycDetailsInformation = (props) => {
  let history = useHistory();
  const [localizationText, setLocalizationText] = useState();
  const [maxEndDate, setMaxEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [state, setState] = useState({
    restaurant_pictures: [],
    restaurant_pictures_new: [],
    progress: 0,
    actionButton: false,
    isPercentage: true,
    errors: {},
  });

  const thumbnail = true;

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  /*************************************
   * @DESC Multiple Image Upload
   ************************************/
  const [combined, setCombined] = React.useState("");
  const [restaurant_pictures_new, setResPicNew] = React.useState([]);
  const onCompleteUploadMultipleCrop = (e, file) => {
    let oldData = formik.values.photos;
    let newData = e;
    let mergedData = oldData.concat(newData);
    formik.setFieldValue("photos", mergedData);
    if (thumbnail) {
      let thumbData = formik.values.photo_thumbnails;
      let url = e.split("/");
      url.splice(url.length - 1, 0, "thumbnail");
      url = url.join("/");
      thumbData = thumbData.concat(url);
      formik.setFieldValue("photo_thumbnails", thumbData);
    }
    let restaurant_pictures_temp = restaurant_pictures_new;
    let newToUpload = restaurant_pictures_temp.filter((item, index) => {
      return item.name !== file.name;
    });
    setResPicNew(newToUpload);
    cancelFiles(file);
  };

  const cancelFiles = (file) => {
    let restaurant_pictures_temp = state.restaurant_pictures_new;
    let newToUpload = restaurant_pictures_temp.filter((item, index) => {
      return item.name !== file.name;
    });
    setState({ ...state, restaurant_pictures_new: newToUpload });
  };

  const bankUploadMultipleFiles = (e) => {
    // this.setState({ bankImageLoader: true });
    if (formik.values.photos.length + e.target.files.length > 6) {
      Alert.error(`<h4>Cannot upload more than 6 images</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      const vendor_id = props.auth.user.VendorUser._id;
      let restaurant_name;
      if (props.onboarding.restaurant_name) {
        restaurant_name = props.onboarding.restaurant_name.split(" ").join("");
      } else {
        restaurant_name = "";
      }
      const combined = vendor_id + "_" + restaurant_name;
      const data = new FormData();
      let flag = false;
      var newUploaded = [];
      var docs = false;
      for (let i = 0; i < e.target.files.length; i++) {
        let allPicures = formik.values.photos;
        allPicures.some((phone) => {
          if (
            phone.split(`${restaurant_name}-`)[1] === e.target.files[i].name
          ) {
            flag = true;
          }
        });
        if (!flag) {
          if (e.target.files[i].type === "application/pdf") {
            docs = true;
            data.append("files", e.target.files[i]);
          } else {
            newUploaded.push(e.target.files[i]);
          }
        }
      }
      if (!flag) {
        setResPicNew(newUploaded);
        setCombined(combined);
        if (docs) {
          axios
            .post(`${serverApi}/upload-assets?uploadSide=${combined}`, data)
            .then((res) => {
              let oldData = formik.values.photos;
              let newData = res.data;
              let mergedData = oldData.concat(newData);
              formik.setFieldValue("photos", mergedData);
              Alert.success(`<h4>Image Upload Successfully</h4>`, {
                position: "top-right",
                effect: "bouncyflip",
                beep: true,
                html: true,
                timeout: 3000,
                offset: 35,
              });
            })
            .catch((err) => {
              Alert.error(`<h4>${err}</h4>`, {
                position: "top-right",
                effect: "bouncyflip",
                beep: true,
                html: true,
                timeout: 3000,
                offset: 35,
              });
            });
        }
      } else {
        Alert.error(`<h4>Can not upload the same image</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
    }
  };

  const bankDocMultipleRemove = (indexId) => {
    let allImages = formik.values.photos.filter((item, index) => {
      return index !== indexId;
    });
    let thumbImage = formik.values.photo_thumbnails.filter((item, index) => {
      return index !== indexId;
    });
    formik.setFieldValue("photos", allImages);
    formik.setFieldValue("photo_thumbnails", thumbImage);
  };

  const formik = useFormik({
    initialValues: {
      vendor_id: "",
      id: "",
      kyc_name_of_company: "",
      kyc_doing_business: "",
      kyc_business_address: "",
      kyc_pin_code: "",
      kyc_area: "",
      kyc_city: "",
      kyc_state: "",
      kyc_date_of_application: "",
      kyc_tan_number: "",
      kyc_shop_act_licence_number: "",
      kyc_liquor_permit_number: "",
      kyc_aadhaar_card_number: "",
      gst_number: "",
      fssai_code: "",
      pan_card: "",
      photos: [],
      photo_thumbnails: [],
      hasSetBankProps: false,
    },
    validationSchema: yup.object({
      kyc_name_of_company: yup
        .string()
        .max(50, "You have reached your maximum limit of characters allowed"),
      kyc_doing_business: yup
        .string()
        .max(50, "You have reached your maximum limit of characters allowed"),
      kyc_business_address: yup
        .string()
        .max(250, "You have reached your maximum limit of characters allowed"),
      kyc_area: yup
        .string()
        .max(50, "You have reached your maximum limit of characters allowed"),
      kyc_city: yup
        .string()
        .max(50, "You have reached your maximum limit of characters allowed"),
      kyc_state: yup
        .string()
        .max(50, "You have reached your maximum limit of characters allowed"),
      gst_number: yup
        .string()
        .matches(gstInFormat, "Please enter valid GST number format")
        .min(15, "Please enter valid 15-digit GST number")
        .max(15, "Please enter valid 15-digit GST number"),
      fssai_code: yup
        .string()
        .min(14, "Please enter valid 14-digit fssai code")
        .max(14, "Please enter valid 14-digit fssai code"),
      pan_card: yup
        .string()
        .matches(pan_cardFormat, "Please enter valid pan card number format")
        .min(10, "Please enter valid 10-characters pan card number")
        .max(10, "Please enter valid 10-characters pan card number"),
      kyc_aadhaar_card_number: yup
        .string()
        .matches(aadhaarCardFormat, "Please enter valid Aadhaar card format")
        .min(14, "Please enter valid 12-characters aadhaar card number")
        .max(14, "Please enter valid 12-characters aadhaar card number"),
      kyc_tan_number: yup
        .string()
        .matches(tanNumberFormat, "Please enter valid tan number format")
        .min(10, "Please enter valid 10-characters tan number")
        .max(10, "Please enter valid 10-characters tan number"),
      kyc_shop_act_licence_number: yup
        .string()
        .min(12, "Please enter valid 12-characters tan number")
        .max(12, "Please enter valid 12-characters tan number"),
      kyc_liquor_permit_number: yup
        .string()
        .min(10, "Please enter valid liquor permits number"),
      photos: yup.array().min(1),
    }),

    onSubmit: (values) => {
      var formData = {};
      formData.vendor_id = values.vendor_id;
      formData.id = values.id;
      formData.kyc_name_of_company = values.kyc_name_of_company;
      formData.kyc_doing_business = values.kyc_doing_business;
      formData.kyc_business_address = values.kyc_business_address;
      formData.kyc_pin_code = values.kyc_pin_code;
      formData.kyc_area = values.kyc_area;
      formData.kyc_city = values.kyc_city;
      formData.kyc_state = values.kyc_state;
      formData.gst_number = values.gst_number;
      formData.fssai_code = values.fssai_code;
      formData.kyc_date_of_application = values.kyc_date_of_application;
      formData.pan_card = values.pan_card;
      formData.kyc_aadhaar_card_number = values.kyc_aadhaar_card_number;
      formData.kyc_tan_number = values.kyc_tan_number;
      formData.kyc_shop_act_licence_number = values.kyc_shop_act_licence_number;
      formData.kyc_liquor_permit_number = values.kyc_liquor_permit_number;
      formData.kyc_photo = values.photos;
      formData.kyc_photo_thumbnails = values.photo_thumbnails;
      if (
        formik.values.fssai_code === "" &&
        formik.values.kyc_date_of_application === ""
      ) {
        formik.setErrors({
          fssai_code: "Please fill any one of the fssai fields",
          kyc_date_of_application: "Please fill any one of the fssai fields",
        });
      } else if (
        formik.values.pan_card === "" &&
        formik.values.kyc_aadhaar_card_number === ""
      ) {
        formik.setErrors({
          pan_card: "Please fill any one of the fssai fields",
          kyc_aadhaar_card_number: "Please fill any one of the fssai fields",
        });
      } else {
        props.buttonNextClickChangeOne(formData);
      }
    },
  });

  const [count, setCount] = useState(1);
  const onClickSave = () => {
    setCount(count + 1);
    formik.handleSubmit();
  };

  useEffect(() => {
    // formik.setFieldValue("kyc_name_of_company", "");
    setLocalizationText(
      !isEmpty(
        props?.auth?.user?.VendorUser &&
          props?.auth?.user?.VendorUser?.country_code &&
          props?.auth?.user?.VendorUser?.country
      )
        ? props?.auth?.user?.VendorUser?.country_code +
            props?.auth?.user?.VendorUser?.country
        : ""
    );
  }, []);

  useEffect(() => {
    if (formik.errors && formik.errors.kyc_name_of_company) {
      let kyc_name_of_companyElement = document.getElementById(
        "kyc_name_of_company"
      );
      kyc_name_of_companyElement.focus();
    } else if (formik.errors && formik.errors.kyc_doing_business) {
      let kyc_doing_businessElement =
        document.getElementById("kyc_doing_business");
      kyc_doing_businessElement.focus();
    } else if (formik.errors && formik.errors.kyc_business_address) {
      let kyc_business_addressElement = document.getElementById(
        "kyc_business_address"
      );
      kyc_business_addressElement.focus();
    } else if (formik.errors && formik.errors.kyc_area) {
      let kyc_areaElement = document.getElementById("kyc_area");
      kyc_areaElement.focus();
    } else if (formik.errors && formik.errors.kyc_city) {
      let kyc_cityElement = document.getElementById("kyc_city");
      kyc_cityElement.focus();
    } else if (formik.errors && formik.errors.kyc_state) {
      let kyc_stateElement = document.getElementById("kyc_state");
      kyc_stateElement.focus();
    } else if (formik.errors && formik.errors.gst_number) {
      let gst_numberElement = document.getElementById("gst_number");
      gst_numberElement.focus();
    } else if (formik.errors && formik.errors.fssai_code) {
      let fssai_codeElement = document.getElementById("fssai_code");
      fssai_codeElement.focus();
    } else if (formik.errors && formik.errors.pan_card) {
      let pan_cardElement = document.getElementById("pan_card");
      pan_cardElement.focus();
    } else if (formik.errors && formik.errors.kyc_aadhaar_card_number) {
      let kyc_aadhaar_card_numberElement = document.getElementById(
        "kyc_aadhaar_card_number"
      );
      kyc_aadhaar_card_numberElement.focus();
    } else if (formik.errors && formik.errors.kyc_tan_number) {
      let kyc_tan_numberElement = document.getElementById("kyc_tan_number");
      kyc_tan_numberElement.focus();
    } else if (formik.errors && formik.errors.kyc_shop_act_licence_number) {
      let kyc_shop_act_licence_numberElement = document.getElementById(
        "kyc_shop_act_licence_number"
      );
      kyc_shop_act_licence_numberElement.focus();
    } else if (formik.errors && formik.errors.kyc_liquor_permit_number) {
      let kyc_liquor_permit_numberElement = document.getElementById(
        "kyc_liquor_permit_number"
      );
      kyc_liquor_permit_numberElement.focus();
    }
  }, [count]);

  useEffect(() => {
    if (props && props?.onboarding) {
      let data = props?.onboarding;
      formik.setFieldValue("vendor_id", data.vendor_id);
      formik.setFieldValue("id", data.id);
      formik.setFieldValue("kyc_name_of_company", data.kyc_name_of_company);
      formik.setFieldValue("kyc_doing_business", data.kyc_doing_business);
      formik.setFieldValue("kyc_business_address", data.kyc_business_address);
      formik.setFieldValue("kyc_pin_code", data.kyc_pin_code);
      formik.setFieldValue("kyc_area", data.kyc_area);
      formik.setFieldValue("kyc_city", data.kyc_city);
      formik.setFieldValue("kyc_state", data.kyc_state);
      formik.setFieldValue(
        "kyc_date_of_application",
        data.kyc_date_of_application
      );
      formik.setFieldValue("kyc_tan_number", data.kyc_tan_number);
      formik.setFieldValue(
        "kyc_shop_act_licence_number",
        data.kyc_shop_act_licence_number
      );
      formik.setFieldValue(
        "kyc_liquor_permit_number",
        data.kyc_liquor_permit_number
      );
      formik.setFieldValue(
        "kyc_aadhaar_card_number",
        data.kyc_aadhaar_card_number
      );
      formik.setFieldValue("gst_number", data.gst_number);
      formik.setFieldValue("fssai_code", data.fssai_code);
      formik.setFieldValue("pan_card", data.pan_card);
      formik.setFieldValue("photos", data.kyc_photo);
      formik.setFieldValue("photo_thumbnails", data.kyc_photo);
    }
  }, [props && props.onboarding]);

  return (
    <React.Fragment>
      <div className="bank_and_other_details_onboarding_main">
        <div className="col-12 p-0">
          <Form.Group>
            <NewInputText
              extraClass="mb-1"
              name="kyc_name_of_company"
              maxLength={50}
              onInput={maxLengthCheck}
              inputType="text"
              onFocusOut={formik.handleBlur}
              onChange={formik.handleChange}
              value={formik.values.kyc_name_of_company}
              labelText="Name Of The Company"
              controlClass="kyc_name_of_company"
            />
            <div className="f10-400 mx-3">
              {formik.errors.kyc_name_of_company &&
              formik.touched.kyc_name_of_company ? (
                <div style={{ color: "#EE3A23" }}>
                  {formik.errors.kyc_name_of_company}
                </div>
              ) : (
                <div style={{ color: "#9E9E9E" }}>*Max 50 Character</div>
              )}
            </div>
          </Form.Group>
          <Form.Group>
            <NewInputText
              extraClass="mb-1"
              name="kyc_doing_business"
              maxLength={50}
              onInput={maxLengthCheck}
              inputType="text"
              onFocusOut={formik.handleBlur}
              onChange={formik.handleChange}
              value={formik.values.kyc_doing_business}
              labelText="Doing Business As"
              controlClass="kyc_doing_business"
            />
            <div className="f10-400 mx-3">
              {formik.errors.kyc_doing_business &&
              formik.touched.kyc_doing_business ? (
                <div style={{ color: "#EE3A23" }}>
                  {formik.errors.kyc_doing_business}
                </div>
              ) : (
                <div style={{ color: "#9E9E9E" }}>*Max 50 Character</div>
              )}
            </div>
          </Form.Group>
          <Form.Group>
            <TextField
              id="kyc_business_address"
              label="Business Address*"
              type="text"
              multiline
              rows={4}
              variant="outlined"
              className={`w-100 ${
                formik.errors.kyc_business_address &&
                formik.touched.kyc_business_address
                  ? "enError"
                  : ""
              }`}
              name="kyc_business_address"
              onChange={formik.handleChange}
              value={formik.values.kyc_business_address}
              onBlur={formik.handleBlur}
            />
            <div className="f10-400 mx-3 mt-1">
              {formik.errors.kyc_business_address &&
              formik.touched.kyc_business_address ? (
                <div style={{ color: "#EE3A23" }}>
                  {formik.errors.kyc_business_address}
                </div>
              ) : (
                <div style={{ color: "#9E9E9E" }}>
                  (Business Address on Amealio need to be written to help users
                  navigate to the place, please include all the details)
                </div>
              )}
            </div>
          </Form.Group>
        </div>
        <div className="row">
          <div className="col-6">
            <Form.Group>
              <NewInputText
                extraClass="mb-1"
                name="kyc_pin_code"
                maxLength={
                  countryJson[localizationText] &&
                  countryJson[localizationText].pinCode
                }
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                onInput={maxLengthCheck}
                inputType="number"
                onKeyDown={InputNumberFunc}
                onFocusOut={formik.handleBlur}
                onChange={formik.handleChange}
                value={formik.values.kyc_pin_code}
                labelText="Pin Code"
                controlClass="kyc_pin_code"
              />
              <div className="f10-400 mx-3 mt-1">
                {formik.errors.kyc_pin_code && formik.touched.kyc_pin_code ? (
                  <div style={{ color: "#EE3A23" }}>
                    {formik.errors.kyc_pin_code}
                  </div>
                ) : (
                  <div style={{ color: "#9E9E9E" }}></div>
                )}
              </div>
            </Form.Group>
          </div>
          <div className="col-6">
            <Form.Group>
              <NewInputText
                extraClass="mb-1"
                name="kyc_area"
                maxLength={50}
                onInput={maxLengthCheck}
                inputType="text"
                onFocusOut={formik.handleBlur}
                onChange={formik.handleChange}
                value={formik.values.kyc_area}
                labelText="Area"
                controlClass="kyc_area"
              />
              <div className="f10-400 mx-3 mt-1">
                {formik.errors.kyc_area && formik.touched.kyc_area ? (
                  <div style={{ color: "#EE3A23" }}>
                    {formik.errors.kyc_area}
                  </div>
                ) : (
                  <div style={{ color: "#9E9E9E" }}></div>
                )}
              </div>
            </Form.Group>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <Form.Group>
              <NewInputText
                extraClass="mb-1"
                name="kyc_city"
                maxLength={50}
                onInput={maxLengthCheck}
                inputType="text"
                onFocusOut={formik.handleBlur}
                onChange={formik.handleChange}
                value={formik.values.kyc_city}
                labelText="City"
                controlClass="kyc_city"
              />
              <div className="f10-400 mx-3 mt-1">
                {formik.errors.kyc_city && formik.touched.kyc_city ? (
                  <div style={{ color: "#EE3A23" }}>
                    {formik.errors.kyc_city}
                  </div>
                ) : (
                  <div style={{ color: "#9E9E9E" }}></div>
                )}
              </div>
            </Form.Group>
          </div>
          <div className="col-6">
            <Form.Group>
              <NewInputText
                extraClass="mb-1"
                name="kyc_state"
                maxLength={50}
                onInput={maxLengthCheck}
                inputType="text"
                onFocusOut={formik.handleBlur}
                onChange={formik.handleChange}
                value={formik.values.kyc_state}
                labelText="State"
                controlClass="kyc_state"
              />
              <div className="f10-400 mx-3 mt-1">
                {formik.errors.kyc_state && formik.touched.kyc_state ? (
                  <div style={{ color: "#EE3A23" }}>
                    {formik.errors.kyc_state}
                  </div>
                ) : (
                  <div style={{ color: "#9E9E9E" }}></div>
                )}
              </div>
            </Form.Group>
          </div>
        </div>
        <div className="col-12 p-0">
          <Form.Group>
            <NewInputText
              extraClass="mb-1"
              name="gst_number"
              maxLength={15}
              onInput={maxLengthCheck}
              inputType="text"
              onFocusOut={formik.handleBlur}
              onChange={formik.handleChange}
              value={formik?.values?.gst_number?.toUpperCase()}
              labelText="GST Number"
              controlClass="gst_number"
            />
            <div className="f10-400 mx-3 mt-1">
              {formik.errors.gst_number && formik.touched.gst_number ? (
                <div style={{ color: "#EE3A23" }}>
                  {formik.errors.gst_number}
                </div>
              ) : (
                <div style={{ color: "#9E9E9E" }}>*Max 15 Character</div>
              )}
            </div>
          </Form.Group>
          <Form.Group>
            <NewInputText
              extraClass="mb-1"
              name="fssai_code"
              maxLength={14}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              onInput={maxLengthCheck}
              inputType="number"
              onKeyDown={InputNumberFunc}
              onFocusOut={formik.handleBlur}
              onChange={formik.handleChange}
              value={formik.values.fssai_code}
              labelText="FSSAI Number"
              controlClass="fssai_code"
            />
            <div className="f10-400 mx-3 mt-1">
              {formik.errors.fssai_code && formik.touched.fssai_code ? (
                <div style={{ color: "#EE3A23" }}>
                  {formik.errors.fssai_code}
                </div>
              ) : (
                <div style={{ color: "#9E9E9E" }}>14-character code</div>
              )}
            </div>
          </Form.Group>
          <h5 className="col-12 f12-400 mb-3">Or</h5>
          <Form.Group>
            <TextField
              id="kyc_date_of_application"
              label="FSSAI Date Of Application"
              type="date"
              variant="outlined"
              className={`w-100 ${
                formik.errors.kyc_date_of_application &&
                formik.touched.kyc_date_of_application
                  ? "enError"
                  : ""
              }`}
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                inputProps: { max: maxEndDate },
              }}
              name="kyc_date_of_application"
              defaultValue={new Date()}
              onChange={formik.handleChange}
              value={formik.values.kyc_date_of_application}
              onBlur={formik.handleBlur}
            />
            <div className="f10-400 mx-3 mt-1">
              {formik.errors.kyc_date_of_application &&
              formik.touched.kyc_date_of_application ? (
                <div style={{ color: "#EE3A23" }}>
                  {formik.errors.kyc_date_of_application}
                </div>
              ) : (
                <div style={{ color: "#9E9E9E" }}>
                  (If you don't have FSSAI code and you have applied for FSSAI,
                  you can give the date of application here)
                </div>
              )}
            </div>
          </Form.Group>
          <Form.Group>
            <NewInputText
              extraClass="mb-1"
              name="pan_card"
              maxLength={10}
              onInput={maxLengthCheck}
              inputType="text"
              onFocusOut={formik.handleBlur}
              onChange={formik.handleChange}
              value={formik?.values?.pan_card?.toUpperCase()}
              labelText="PAN/ Tax Number"
              controlClass="pan_card"
            />
            <div className="f10-400 mx-3 mt-1">
              {formik.errors.pan_card && formik.touched.pan_card ? (
                <div style={{ color: "#EE3A23" }}>{formik.errors.pan_card}</div>
              ) : (
                <div style={{ color: "#9E9E9E" }}>10-character code</div>
              )}
            </div>
          </Form.Group>
          <h5 className="col-12 f12-400 mb-3">Or</h5>
          <Form.Group>
            <NewInputText
              extraClass="mb-1"
              name="kyc_aadhaar_card_number"
              maxLength={14}
              onKeyPress={(event) => {
                if (aadhaarCardFormat.test(event.key)) {
                  event.preventDefault();
                }
              }}
              onInput={maxLengthCheck}
              inputType="text"
              // onKeyDown={InputNumberFunc}
              onFocusOut={formik.handleBlur}
              onChange={formik.handleChange}
              value={formik?.values?.kyc_aadhaar_card_number}
              labelText="Aadhaar Card Number"
              controlClass="kyc_aadhaar_card_number"
            />
            <div className="f10-400 mx-3 mt-1">
              {formik.errors.kyc_aadhaar_card_number &&
              formik.touched.kyc_aadhaar_card_number ? (
                <div style={{ color: "#EE3A23" }}>
                  {formik.errors.kyc_aadhaar_card_number}
                </div>
              ) : (
                <div style={{ color: "#9E9E9E" }}>
                  12-character code Ex: 8888 8888 8888
                </div>
              )}
            </div>
          </Form.Group>
          <Form.Group>
            <NewInputText
              extraClass="mb-1"
              name="kyc_tan_number"
              maxLength={10}
              onInput={maxLengthCheck}
              inputType="text"
              onFocusOut={formik.handleBlur}
              onChange={formik.handleChange}
              value={formik?.values?.kyc_tan_number?.toUpperCase()}
              labelText="Tan Number"
              controlClass="kyc_tan_number"
            />
            <div className="f10-400 mx-3 mt-1">
              {formik.errors.kyc_tan_number && formik.touched.kyc_tan_number ? (
                <div style={{ color: "#EE3A23" }}>
                  {formik.errors.kyc_tan_number}
                </div>
              ) : (
                <div style={{ color: "#9E9E9E" }}>10-character code</div>
              )}
            </div>
          </Form.Group>
          <Form.Group>
            <NewInputText
              extraClass="mb-1"
              name="kyc_shop_act_licence_number"
              maxLength={12}
              onInput={maxLengthCheck}
              inputType="text"
              onFocusOut={formik.handleBlur}
              onChange={formik.handleChange}
              value={formik?.values?.kyc_shop_act_licence_number}
              labelText="Shop Act Licence Number"
              controlClass="kyc_shop_act_licence_number"
            />
            <div className="f10-400 mx-3 mt-1">
              {formik.errors.kyc_shop_act_licence_number &&
              formik.touched.kyc_shop_act_licence_number ? (
                <div style={{ color: "#EE3A23" }}>
                  {formik.errors.kyc_shop_act_licence_number}
                </div>
              ) : (
                <div style={{ color: "#9E9E9E" }}>12-character code</div>
              )}
            </div>
          </Form.Group>
          <Form.Group>
            <NewInputText
              extraClass="mb-1"
              name="kyc_liquor_permit_number"
              maxLength={15}
              onInput={maxLengthCheck}
              inputType="text"
              onFocusOut={formik.handleBlur}
              onChange={formik.handleChange}
              value={formik?.values?.kyc_liquor_permit_number}
              labelText="Liquor Permit Number"
              controlClass="kyc_liquor_permit_number"
            />
            <div className="f10-400 mx-3 mt-1">
              {formik.errors.kyc_liquor_permit_number &&
              formik.touched.kyc_liquor_permit_number ? (
                <div style={{ color: "#EE3A23" }}>
                  {formik.errors.kyc_liquor_permit_number}
                </div>
              ) : (
                ""
              )}
            </div>
          </Form.Group>
        </div>
        <Row>
          <Col md={12}>
            <div className="bank-kyc-photos-image">
              <SimpleReactLightbox>
                <MultipleImageUploadComponent
                  title="Upload Images"
                  smallTitle="(Upload supporting documents for PAN, GST, FSSAI and other business documents as applicable MoU)"
                  onChange={bankUploadMultipleFiles}
                  stateValue={formik.values.photos}
                  newUploaded={
                    restaurant_pictures_new ? restaurant_pictures_new : []
                  }
                  combined={combined}
                  onCompleteUploadMultipleCrop={onCompleteUploadMultipleCrop}
                  removeImage={bankDocMultipleRemove}
                  cancelFiles={cancelFiles}
                  accept="image/gif,image/jpeg,image/jpg,image/png,.pdf"
                  thumbnail={thumbnail}
                  // loader={this.state.multipleImageLoader}
                />
              </SimpleReactLightbox>
            </div>

            <div className="f10-400 mx-3 mt-1 mb-3">
              {formik.errors.kyc_photo && formik.touched.kyc_photo ? (
                <div style={{ color: "#EE3A23" }}>
                  {formik.errors.kyc_photo}
                </div>
              ) : (
                <div className="mb-3"> </div>
              )}
            </div>
          </Col>
        </Row>
        <div className="f11-400 opacity5 mb-3">
          You may receive a call for KYC and Confirmation
        </div>
        <div className="onboarding-map-setup-screen-autodetect-button">
          <ReusableOnboardingButton
            buttonTitle="Back Button"
            buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
            buttonText="Back"
            buttonType="button"
            onClick={props.backSecondScreenClickChange}
          />
          <ReusableOnboardingButton
            buttonClass={
              (formik.values.fssai_code === "" &&
                formik.values.kyc_date_of_application === "") ||
              (formik.values.pan_card === "" &&
                formik.values.kyc_aadhaar_card_number === "")
                ? "onboarding_button_link_reusable onboarding_button_link_reusable_gray ml-3"
                : "onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
            }
            type="submit"
            onClick={() => onClickSave()}
            // buttonType={actionButton === false ? "button" : "submit"}
            buttonText="Next"
          />
        </div>
      </div>
    </React.Fragment>
  );
};

BankKycDetailsInformation.propTypes = {
  auth: PropTypes.object.isRequired,
  error: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  error: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
});

export default connect(mapStateToProps, {
  // vendor_create_new_offer,
})(BankKycDetailsInformation);
